import Badge from '@material-ui/core/Badge';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

import PatrolPropertyComponent from '../PatrolPropertyComponent';
import * as colors from '../../../styles/colors';
import isCardinalActive from '../../../utils/isCardinalActive';

const PropertyMarker = ({ property, onClick, selected }) => {
  let { color, zIndex, patrols } = property.markerParams;
  if (selected) {
    color = colors.markers.property.SELECTED;
    zIndex = 100;
  }
  const classes = useStyles({ isPatrol: Boolean(patrols), zIndex });

  const customComponent = patrols ? (
    <PatrolPropertyComponent
      color={color}
      count={patrols.count}
      timeRemainingPercentage={patrols.timeRemainingPercentage}
    />
  ) : (
    <PropertyComponent color={color} />
  );

  return (
    <div
      className={classes.absolutePosition}
      style={{ transform: patrols ? 'translate(-50%, -100%)' : 'translate(-50%, -50%)' }}
    >
      <div className={classes.root} onClick={onClick}>
        {isCardinalActive(property.cardinal) ? (
          <Badge
            classes={{ anchorOriginTopRightRectangle: classes.badge }}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            badgeContent={<span>VIP</span>}
            color='primary'
            invisible={false}
            overlap='rectangle'
          >
            {customComponent}
          </Badge>
        ) : (
          customComponent
        )}
      </div>
    </div>
  );
};

export const PropertyComponent = ({ color }) => {
  const classes = useStyles({ color });
  return <div className={classes.dot} />;
};

const useStyles = makeStyles(() => ({
  absolutePosition: {
    position: 'absolute',
    zIndex: props => props.zIndex
  },
  root: {
    minWidth: 16,
    minHeight: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  },
  badge: {
    height: 14,
    paddingLeft: 4,
    paddingRight: 4,
    fontSize: 10,
    color: colors.WHITE,
    backgroundColor: 'goldenrod',
    transform: props => props.isPatrol ? 'translate(20%, -70%)' : 'translate(16%, -70%)'
  },
  dot: {
    width: 16,
    height: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 12,
    overflow: 'hidden',
    backgroundColor: props => props.color
  }
}));

export default PropertyMarker;